import { createQueryKeys } from "@lukemorales/query-key-factory";
import { PanicType } from "..";

export const panicTypes = createQueryKeys("panicTypes", {
  getAllPanicTypes: null,
});
